<template>
    <section class="slice slice-trends-chart" :class="{'slice-trends-chart--grey': backgroundColor === 'grey'}">
        <div class="slice-content">
            <TitleBrand :field="slice.primary.title" class="title-brand" />
            <TrendsChartScatter v-if="slice.primary.type === 'scatter'" :data="data" :axis-x="axisX" :axis-y="axisY" />
            <TrendsChartBar v-if="slice.primary.type === 'bar'" :data="data" />
        </div>
    </section>
</template>
<script setup lang="ts">
    import {computed} from 'vue';
    import type {Content} from '@prismicio/client';
    import {getSliceComponentProps} from '@prismicio/vue';

    import TitleBrand from '~/components/TitleBrand.vue';
    import TrendsChartBar from '~/components/trends/chart/TrendsChartBar.vue';
    import TrendsChartScatter from '~/components/trends/chart/TrendsChartScatter.vue';
    import type {TrendsDemandQuadrantNumericKey} from '~/types/TrendsData';

    const props = defineProps(getSliceComponentProps<Content.TrendsChartSlice>(['slice', 'index', 'slices', 'context']));
    const backgroundColor = computed(() => props.slice.primary.backgroundColor);

    const data = props.slice.primary.data;

    const axisX = {
        label: props.slice.primary.axisXLabel ?? 'Growth',
        key: props.slice.primary.axisXKey as TrendsDemandQuadrantNumericKey,
    };
    const axisY = {
        label: props.slice.primary.axisYLabel ?? 'Volume',
        key: props.slice.primary.axisYKey as TrendsDemandQuadrantNumericKey,
    };
</script>
<style lang="scss">
    .slice-trends-chart {
        &--grey {
            background-color: var(--joy-color-neutral-20);
        }
    }
</style>
